import React, { useState, useEffect, useContext, createRef } from 'react'
import { Modal } from 'react-bootstrap'
import EditCompanyDetailsForm from './editCompanyDetailsForm'
import { Vendor } from '../../../../models/Vendor'
import { getFilteredCountries } from '../../../../services/countryService'
import { editCompanyProfile } from '../../../../services/vendorService'
import { VendorContext } from '../../../../contexts/vendorContext'
import { friendlyMessageFor } from '../../../../utility/errorHelper'
import { toast } from 'react-toastify'
import constants from '../../../../config/constants'
import { Country } from '../../../../models/Country'

type EditModal = {
  show: boolean
  handleClose: () => void
  vendor?: Vendor
}

function EditCompanyDetailsModal({ show, handleClose, vendor }: EditModal) {
  const wrapper = createRef<HTMLDivElement>()
  const vendorContext = useContext(VendorContext)
  const [countries, setCountries] = useState<Array<Country>>([])
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const availableCountries = [
      ...constants.workCountries,
      ...constants.homeCountries
    ]
    getFilteredCountries(availableCountries).then(countryList => {
      setCountries(countryList)
    })
  }, [])

  return (
    <div ref={wrapper} data-testid="editCompanyDetailsModalFC">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title data-testid="modal-title">
            Edit company details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditCompanyDetailsForm
            companyProfile={vendor}
            countries={countries}
            isSubmitting={isSubmitting}
            callback={(countryId, logoUrl, email, phonenumber, description) => {
              let hasChanges = false

              // Update companyProfile if the values has changed
              if (
                countryId !==
                  vendorContext?.companyProfile?.originCountry?.id ||
                (logoUrl?.length &&
                  logoUrl !== vendorContext?.companyProfile?.logoUrl) ||
                email !== vendorContext?.companyProfile?.email ||
                phonenumber !== vendorContext?.companyProfile?.phonenumber ||
                description !== vendorContext?.companyProfile?.bio
              ) {
                hasChanges = true
                setIsSubmitting(true)

                editCompanyProfile(
                  countryId,
                  logoUrl,
                  email,
                  phonenumber,
                  description
                )
                  .then(updatedProfile => {
                    if (updatedProfile) {
                      vendorContext?.setCompanyProfile(updatedProfile)
                      setIsSubmitting(false)
                      toast.success(
                        constants.alertMessage.docUpdated.replace(
                          '%s',
                          'Company details'
                        )
                      )
                      handleClose()
                    } else {
                      // @TODO: figure out the case where this will happen
                      // For now display generic error message
                      const message = friendlyMessageFor(null)
                      toast.error(message, { autoClose: false })
                      setIsSubmitting(false)
                    }
                  })
                  .catch(err => {
                    console.error('Vendor edit profile error:', err)
                    toast.error(err, { autoClose: false })
                    setIsSubmitting(false)
                  })
              }

              // If there are no changes, simply dismiss the form
              if (!hasChanges) {
                handleClose()
              }
            }}
          />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default EditCompanyDetailsModal
